import { render, staticRenderFns } from "./open-spreads-output.vue?vue&type=template&id=f09cc39e&"
import script from "./open-spreads-output.vue?vue&type=script&lang=js&"
export * from "./open-spreads-output.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports